export default {
    "occurrence": {
        "titles": "Ocorrências",
        "title": "Ocorrência",
        "show_title": "Detalhes da Ocorrência",
        "add_title": "Nova Ocorrência",
        "edit_title": "Editar Ocorrência",
        "notify_title": "Notificar",
        "form": {
            "show_details": "Visualizar Detalhes",
            "show_history": "Visualizar Histórico",
            "details_title": "Detalhes da ocorrência",
            "history_title": "Histórico da ocorrência",
            "add_image_title": "Adicione uma imagem ao registo",
            "add_image_descr": "Pode captar agora uma fotografia ou escolher uma imagem da galeira do seu telemóvel",
            "camera": "Câmara fotográfica",
            "gallery": "Galeria de Imagens",
            "type_title": "Qual o tipo de ocorrência?",
            "subtype_title": "Qual das opções descreve melhor a ocorrência?",
            "commun_title": "São necessários mais detalhes",
            "commun_subtitle": "Fale nos mais sobre esta ocorrência",
            "select_user": "Seleccionar Utilizador",
            "user": {
                "title": "Utilizador",
                "placeholder": "Utilizador...",
                "create_title": "Criar Utilizador"
            },
            "msg": {
                "add": {
                    "help": "Clique no mapa para escolher o local da ocorrência.",
                    "not_allowed": "Não possui permissão para adicionar uma nova ocorrência",
                    "out_boundary": "Não é possível registar ocorrência fora do concelho.",
                    "active_filter": "Necessário ativar os filtros para visualizar a ocorrência.",
                },
                "edit": {
                    "updated_by_another_user": "<b>Atenção</b>: Esta ocorrência <strong class='font-weight-bold'>{code}</strong> foi alterada por outro utilizador.",
                },
                "history": {
                    "not_found": "Não existe histórico para essa ocorrência.",
                },
                "confirm": {
                    "delete_item": "Deseja eliminar a ocorrência <strong class='font-weight-bold'>{code}</strong>?",
                    "create_edocklink": "Pretende criar o registo no EdocLink?",
                    "follow": "Pretende seguir esta ocorrência?",
                    "unfollow": "Deixar de seguir esta ocorrência?"
                }
            },
            "feature": {
                "section_title": "Elemento",
                "select_title": "Selecione o elemento sobre o qual pretende criar uma ocorrência",
                "compose_title": "{title}: {entity} ({code})",
            },
            "buttons": {
                "next": "Continuar",
                "previous": "Recuar",
                "finish": "Reportar",
                "another_photo": "Captar novamente",
                "take_photo": "Captar",
                "report_by": "Utilizador",
                "save": "Salvar",
                "edit": "Editar",
                "delete": "Eliminar",
                "notify": "Notificar",
                "share": "Partilhar",
                "createEdocLink": "Gerar EdocLink",
                "open_edoc_link": "Abrir Edoclink",
                "update_edoc_link": "Alterar Edoclink",
                "user": {
                    "cancel": "Cancelar",
                    "select": "Selecionar",
                    "update": "Atualizar Utilizador",
                    "create": "Criar Utilizador",
                    "show": "Utilizador"
                },
                "detail": {
                    "show": "Detalhes"
                },
                "feature": {
                    "show": "Elemento"
                },
                "history": {
                    "show": "Histórico"
                },
                "follow": {
                    "follow": "Seguir",
                    "unfollow": "Deixar de Seguir",
                },
                "cancel": "Cancelar",
                "without_select_feature": "Avançar sem Seleção",
            }
        },
        "model": {
            "code": "Código",
            "type": "Tipo",
            "subtype": "Subtipo",
            "channel": "Canal de Entrada",
            "status": "Estado",
            "priority": "Prioridade",
            "address": "Morada",
            "reference_point": "Ponto de referência",
            "initial_description": "Descrição Inicial",
            "description": "Descrição",
            "services": "Serviços",
            "notes": "Notas",
            "photos": "Fotos",
            "created_at": "Data",
            "updated_at": "Alteração",
            "reported_by": "Reportado por",
            "reported_by_placeholder": "Utilizador...",
            "unity": "Atribuir a",
            "unity_label": "Atribuído a",
            "assign": "Responsável",
            "visibility": "Visibilidade",
            "visibility_label": "Visibilidade privada",
            "visibility_private": "Visibilidade @:occurrence.model.private",
            "visibility_template": "Visibilidade <span class='text-warning'>@:occurrence.model.private</span> | Visibilidade <span class='text-warning'>@:occurrence.model.public</span>",
            "private": "privada",
            "public": "pública",
            "active": "Ativa | Ativas",
            "inactive": "Inativa | Inativas",
            "follow": "Seguir esta ocorrência",
            "unfollow": "Não seguir esta ocorrência",
            "period": "Intervalo de Tempo",
            "user_consent": "Consentimento",
            "edoclink": {
                "title": "Edoclink",
                "key": "Key",
                "code": "Code"
            },
            "log": {
                "channel": "@:occurrence.model.channel",
                "priority": "@:occurrence.model.priority",
                "private": "Privada",
                "type": "Tipo / Subtipo",
                "address": "@:occurrence.model.address",
                "reference_point": "@:occurrence.model.reference_point",
                "assign": "@:occurrence.model.assign",
                "phone": "@:occurrence.model.user.phone",
                "email": "@:occurrence.model.user.email",
                "initial_description": "@:occurrence.model.initial_description",
                "description": "Notas",
                "updated_by": "Atualizada por",
            },
            "user": {
                "user": "Utilizador",
                "name": "Nome",
                "email": "E-mail",
                "phone": "Contato",
                "nif": "NIF",
                "address": "Morada"
            },
            "feature": {
                "column": "Elemento",
                "code": "Código",
                "name": "Nome",
                "integration_id": "Código Integração",
                "entity_id": "Camada",
                "entity_name": "Camada",
            }
        },
        "export": {
            "data": {
                "csv": {
                    "name": "CSV",
                    "title": "Exportar para @:occurrence.export.data.csv.name",
                },
                "xls": {
                    "name": "Excel",
                    "title": "Exportar para @:occurrence.export.data.xls.name",
                },
                "kml": {
                    "name": "KML",
                    "title": "Exportar para @:occurrence.export.data.kml.name",
                },
                "gml": {
                    "name": "GML",
                    "title": "Exportar para @:occurrence.export.data.gml.name",
                },
                "geojson": {
                    "name": "Geojson",
                    "title": "Exportar para @:occurrence.export.data.geojson.name",
                },
                "shp": {
                    "name": "Shapefile",
                    "title": "Exportar para @:occurrence.export.data.shp.name",
                },
                "gpkg": {
                    "name": "GeoPackage",
                    "title": "Exportar para @:occurrence.export.data.gpkg.name",
                },
                "pdf": {
                    "name": "PDF",
                    "title": "Exportar para @:occurrence.export.data.pdf.name",
                },
                "ine": {
                    "name": "INE - Centróides",
                    "title": "Exportar os centróides para o INE",
                },
            }
        },
        "help": {
            "create_user" : "Para criar um utilizador, deve indicar pelo menos um dos seguintes campos: Email ou Contato"
        },
        "msg": {
            "featureable": {
                "no_data": "Sem elementos no ponto selecionado",
                "error": "Ocorreu um erro na obtenção da informação para o ponto selecionado",
            },
            "created": "Nova ocorrência <strong>{code}</strong> criada na plataforma",
        }
    },
    "reports": {
        "global_status": {
            "title": "Informações Globais",
        },
        "monthly_summary": {
            "title": "Resumo Mensal",
        },
        "performer_summary": {
            "title": "Ocorrências por Executante",
        },
        "occurrences_summary": {
            "title": "Listagem de Ocorrências",
        },
        "status_chart": {
            "title": "Gráfico dos Estados",
        },
        "subtype_chart": {
            "title": "Gráfico das Tipologias",
        },
    },
    "search": {
        "title": "Lista de ocorrências",
        "label": "Filtros",
        "user": {
            "placeholder": "Utilizador..."
        },
        "buttons": {
            "clear": "Limpar pesquisa",
            "search": "Pesquisar",
            "applyOnMap": "Aplicar no mapa",
            "resetMap": "Limpar mapa"
        },
        "table": {
            "title": "@:search.title",
            "view": "Consultar Informação",
            "viewOnMap": "Visualizar no mapa",
        },
        "msg": {
            "export": {
                "confirm": "Pretende {txt}?",
                "processing": "Exportação de <b>{total} elemento</b> em  execução... | Exportação de <b>{total} elementos</b> em  execução...",
                "finished": "Exportação de <b>{total} elemento</b> concluída | Exportação de <b>{total} elementos</b> concluída",
            },
        }
    },
    "report": {
        "title": "Relatórios",
        "global_total": "No total",
        "monthly_summary": {
            "year": "Ano",
            "month": "Mês"
        },
        "performer_summary": {
            "unity": "Executante"
        },
    },
    "activity": {
        "title": "Atividade Recente",
        "tooltip": "Existem {number} novas ocorrências",
        "no_records": "Sem registos",
        "toggles": {
            "submitted": {
                "title": "Submetidas"
            },
            "completed": {
                "title": "Concluídas"
            }
        },
        "item": {
            "link_map": "ver no mapa",
            "code": "Código",
            "feature": "Elemento",
            "description": "Descrição",
            "address": "Morada",
            "created_at": "Data de criação"
        },
        "msg": {
            "confirm": {
                "reload": "Deseja efetuar o reload da informação?"
            }
        }
    },
    "overdue": {
        "title": "Alarmística",
        "tooltip": "Existem {number} ocorrências em atraso",
        "load_more_records": "Carregar mais",
        "no_records": "Sem registos",
        "item": {
            "link_map": "ver no mapa",
            "code": "Código",
            "address": "Morada",
            "created_at": "Data de criação",
            "days_overdue": "Dia de atraso | Dias de atraso"
        },
        "msg": {
            "confirm": {
                "reload": "Deseja efetuar o reload da informação?"
            }
        }
    },
    "accountable": {
        "title": "Minhas Ocorrências",
        "toggles": {
            "mine": {
                "title": "Minhas Ocorrências"
            },
            "assigned_me": {
                "title": "Atribuídas a mim"
            },
            "my_unities": {
                "title": "Atribuídas à unidade"
            },
        },
        "item": {
            "link_map": "ver no mapa",
            "code": "Código",
            "description": "Descrição",
            "address": "Morada",
            "created_at": "Data de criação",
        },
        "msg": {
            "no-data": "@:global.no-data",
            "confirm": {
                "reload": "Deseja efetuar o reload da informação?"
            }
        }
    },
    "navsearch": {
        "occurrence": {
            "title": "Ocorrência",
            "placeholder": "Ocorrência..."
        }
    }
}
